import React, { MutableRefObject } from "react";

import AddIcon from "@material-ui/icons/LocalHospitalOutlined";
import Button from "@material-ui/core/Button";
import ChangeIcon from "@material-ui/icons/NextWeekOutlined";
import Popover from "@material-ui/core/Popover";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useAppSelector } from "hooks/redux/useAppSelector";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import TickInCircle from "components/Icons/TickInCircle";

import useStyles from "./styles";

interface IProps {
  onClose: () => void;
  onAddHorseToTrackPopupOpen: () => void;
  onChangeTrainerPopupOpen: () => void;
  onRemoveHorsePopupOpen: () => void;
  menuButtonRef: MutableRefObject<HTMLButtonElement>;
  currentHorse: racehorse360.IHorse;
}

const ActionsMenuPopover = (props: IProps) => {
  const {
    onClose,
    menuButtonRef,
    onAddHorseToTrackPopupOpen,
    onChangeTrainerPopupOpen,
    onRemoveHorsePopupOpen,
    currentHorse
  } = props;

  const classes = useStyles();
  const {
    currentUser: { isRacingOfficial, isVeterinarian, isAdmin, isTrainer }
  } = useLoggedInUser();
  const facilities = useAppSelector(state => state.facilities.facilities);

  const isAddHorseToTrackButtonDisabled = [
    facilities.length === 1,
    facilities[0].id === currentHorse.currentFacility?.id
  ].every(Boolean);

  const handleAddHorseToTrackClick = () => {
    onAddHorseToTrackPopupOpen();
    onClose();
  };

  const handleChangeTrainerClick = () => {
    onChangeTrainerPopupOpen();
    onClose();
  };

  const handleRemoveHorseClick = () => {
    onRemoveHorsePopupOpen();
    onClose();
  };

  const shouldShowAddHorseToTrackButton = [
    isVeterinarian,
    isRacingOfficial,
    isAdmin
  ].some(Boolean);
  const shouldShowChangeTrainerButton = [
    isVeterinarian,
    isRacingOfficial,
    isAdmin
  ].some(Boolean);
  const shouldShowRemoveHorseButton = [
    isTrainer,
    isRacingOfficial,
    isAdmin
  ].some(Boolean);

  return (
    <Popover
      anchorEl={menuButtonRef.current}
      onClose={onClose}
      open={true}
      classes={{
        paper: classes.paper
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
    >
      {shouldShowAddHorseToTrackButton && (
        <Button
          className={classes.menuItem}
          startIcon={<AddIcon />}
          onClick={handleAddHorseToTrackClick}
          disabled={isAddHorseToTrackButtonDisabled}
        >
          Add Horse to Track
        </Button>
      )}
      {shouldShowChangeTrainerButton && (
        <Button
          className={classes.menuItem}
          startIcon={<ChangeIcon />}
          onClick={handleChangeTrainerClick}
        >
          Change Trainer
        </Button>
      )}
      {shouldShowRemoveHorseButton && (
        <Button
          className={classes.menuItem}
          startIcon={<TickInCircle />}
          onClick={handleRemoveHorseClick}
          disabled={Boolean(!currentHorse.trainer)}
        >
          Remove From Inventory
        </Button>
      )}
    </Popover>
  );
};

export default ActionsMenuPopover;
